module.exports = __webpack_public_path__ + "static/img/slide1.c7901722.jpg";